module.exports = __webpack_public_path__ + "static/media/narrativ_text_white.60af334a.svg";